import { useAppDispatch } from '@/shared/lib/redux'
import { IBooking } from '@/shared/api/aviabooking'
import { openCancelBookingModal } from '../model'

export const useCancelBookingModal = () => {
    const dispatch = useAppDispatch()

    const openModal = (booking: IBooking, onCancel?: () => void) => {
        dispatch(openCancelBookingModal({
            booking,
            onCancel
        }))
    }
    
    return {
        openModal,
    }
}